import {
  BW_COLOR_LITE_BLACK,
  BW_LANGUAGE_EN
} from 'src/libs/qb-brand-web-components'

const brandConfig = {
  brandId: 'moda_health',
  name: 'EarnWell Rewards',
  customBrandId: 'earnwell',
  faqEmail: 'rewards@earnwellrewards.com',
  websiteUrl: 'https://earnwellrewards.com/',
  privacyPolicyUrl: 'https://www.modahealth.com/privacy/index.shtml',
  termsUrl: 'https://earnwellrewards.com/static/assets/terms_conditions.pdf',
  theme: {
    colors: {
      main: '#e6edef',
      accent: '#005d83',
      liteBlack: '#262626',
      liteWhite: '#ffffff',
      popupBg: '#e6edef' // Using this custom color for popup background and panel text
    }
  },
  supportedLanguages: [BW_LANGUAGE_EN],
  features: {
    enableCOEStorefrontRedeem: true,
    enableImpactReport: true
  },
  cognito: {
    region: 'us-east-1',
    poolId: 'us-east-1_WPlUzumEu',
    clientId: '5s9uuqfokds6h9krm9jrgc1bt9',
    poolDomain: 'moda-health.auth.us-east-1.amazoncognito.com',
    redirectUri: 'https://earnwellrewards.com/login'
  },
  gaTrackingId: 'G-0HSDP6HRXS',
  hotjarId: '2876197',
  facebookPixelId: '',
  prefIconColor: BW_COLOR_LITE_BLACK,
  linkTextDecoration: 'underline',
  membershipAgreementUrl:
    'https://earnwellrewards.com/static/assets/membership_agreement.pdf',
  invertTopBar: true,
  loyalizePid: '8719211'
}

export default brandConfig
